import { ApiResponse } from '../../types/ApiResponse.types';
import { CinemaRoomDto } from '../cinema-room/CinemaRoomDto.types';
import { SeatCategoryDto } from '../seat-category/SeatCategoryDto.types';
import { SeatPositionDto } from '../seat-position/SeatPositionDto.types';
import { ShapeDto } from '../shape/ShapeDto.types';
import { TransformDto } from '../transform/TransformDto.types';

export enum SeatType {
    SEAT = 'seat',
    LOVESEAT_LEFT = 'loveseat_left',
    LOVESEAT_RIGHT = 'loveseat_right',
    DISABLED = 'disabled',
    WHEELCHAIR = 'wheelchair',
    /** One place of a double bed (bed cinema); a bed is a left/right pair, two places, two tickets. */
    BED_LEFT = 'bed_left',
    BED_RIGHT = 'bed_right',
    /** A beanbag: one place. */
    BEANBAG = 'beanbag',
    /** @deprecated be careful to use it, on the backend it's not implemented yet   */
    D_BOX = 'd_box'
}

export type SeatDto = {
    id: number;
    cinemaRoomId: CinemaRoomDto['id'];
    seatShapeId: ShapeDto['id'];
    seatTransformId: TransformDto['id'];
    type: SeatType;
    /** D-Box motion seat. */
    isDbox?: boolean;
    /** The ticket system's id for this seat; `null` for seats created in the Room Studio. */
    ticketSystemId?: string | null;
    /**
     * ISO time the ticket-system sync created this seat in a studio-managed room; `null` once the operator
     * placed it (saved its transform).
     */
    placementPendingSince?: string | null;
} & ApiResponse<
    unknown,
    {
        cinemaRoom?: CinemaRoomDto;
        seatShape?: ShapeDto;
        seatTransform?: TransformDto;
        seatPosition?: SeatPositionDto;
        seatCategory?: SeatCategoryDto;
    }
>;
